export default __webpack_public_path__ + "static/media/main-firefox-bg.2a49e616.png";